<template>
  <div
    class="manage-product-item"
    :class="[{ 'is-tag': is_tag }, { 'is-selected': item.is_selected }, {'is-disabled': is_disabled}]"
    @click="!is_disabled && emit('select', item)"
  >
    <figure>
      <!-- <div v-if="is_home" class="featured-icon" @click.stop="event.emit('feature-item', product)" :class="[{'is-feature': product.is_feature}]"><svg-icon name="star-filled" /></div> -->
      <div class="availability-icon" v-if="store.project === 'sephora' && product_detail.availability === 0">
        <div class="availability-icon-text"> 
          <svg-icon name="eye-hidden" />
          <p>This product is unavailable and will not display in your storefront.</p>
        </div>
      </div>
      <div class="overlay">
        <div class="actives">
          <div class="icon drag-handle" v-if="!is_disabled_content"><svg-icon name="move" /></div>
          <!-- <div class="icon" @click.stop="event.emit('feature-item', product)" :class="{ 'is-feature': product.is_feature }">
            <svg-icon name="star-filled" />
          </div> -->
        </div>

        <div class="bottom-actives">
          <div class="icon" @click.stop="openShare"><svg-icon style="height: 12px; width: 12px;" name="share" /></div>
          <div class="icon" @click.stop="addTo" v-if="props.collection?.status!== STATUS_CODE.Active"><svg-icon name="bookmark" /></div>
          <div v-if="!is_home && !is_disabled_content" class="icon" @click.stop="deleteItem"><svg-icon name="delete2" /></div>
        </div>
      </div>
      <el-image :src="product_detail.images.img_400x400" fill="contain" alt="product image" />
    </figure>

    <h3 class="name">{{ product_detail.name }}</h3>

    <div class="bot" @click.stop>
      <span class="price">{{ product_detail.lowest_price }}</span>
      <i class="tag-ico" v-if="is_tag" @click="emit('select', item)">
        <svg-icon name="checked-circle" />
      </i>
      <el-dropdown trigger="click" popper-class="manage-dropdown-menu manage-product-dropdown-menu">
        <el-button type="text">
          <svg-icon name="menu" />
        </el-button>
        <template #dropdown>
          <el-dropdown-menu>
            <!-- <el-dropdown-item v-if="!is_disabled" @click="event.emit('feature-item', product)">{{
              product.is_feature ? 'Unfeature' : 'Feature on homepage'
            }}</el-dropdown-item> -->     
            <el-dropdown-item v-if="!is_disabled && props.collection?.status!== STATUS_CODE.Active" @click="addTo">Add/Remove from Collections</el-dropdown-item>
            <el-dropdown-item v-if="!is_disabled" @click="openShare">View product</el-dropdown-item>
            <el-dropdown-item v-if="!is_home && !is_disabled_content" class="delete-item" @click="deleteItem">Remove product</el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
  </div>
</template>

<script setup>
import { ref, computed,getCurrentInstance } from 'vue';
import handleProductData from '@/utils/HandleProductData';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { ElDropdown, ElDropdownMenu, ElDropdownItem, ElButton, ElImage } from 'element-plus';
import { useStorefrontFunction } from '@/components/storefront/StorefrontFunction.js';
const store = useStore();
const route = useRoute();

const { STATUS_CODE } = useStorefrontFunction();
const app= getCurrentInstance();
const event = app.appContext.config.globalProperties.EventBus;
const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
  is_home: {
    type: Boolean,
    default: false,
  },
  is_tag: {
    type: Boolean,
    default: false,
  },
  is_in_collection: {
    type: Boolean,
    default: false,
  },
  is_in_post: {
    type: Boolean,
    default: false,
  },
  is_disabled_content: {
    type: Boolean,
    default: false,
  },
  collection:{
    type: Object,
    default: null,
  }
});

const emit = defineEmits(['select']);
const product = ref(props.item.resource_data ? props.item.resource_data.product : props.item);
if (!product.value.type) {
  product.value.type = 'product';
}
const product_detail = ref(handleProductData(product.value.product_detail || product.value.product));
const is_disabled = computed(() => {
  return store.project === 'sephora' && product_detail.value.availability === 0;
});

const addTo = () => {
  event.emit('add-products-to-collections', [product_detail.value.id]);
};

const deleteItem = () => {

  if (props.is_in_post) {
    if (props.is_tag && is_disabled.value) {
      emit('delete-product', product.value.id);
    } else {
      emit('delete-product', [product.value.id]);
    }
    
  } else if (props.is_in_collection) {
    if (props.is_tag && is_disabled.value) {
      emit('delete-product', product.value.product_id);
    } else {
      emit('delete-product', [product.value.product_id]);
    }

  } else if (route.params.type === 'products' && props.is_tag && is_disabled.value) {
    emit('delete-product', product.value.product_id);
  } else {
    event.emit('delete-item', product.value);
  }
};

const openShare = () => {
  window.open(product.value.product.affiliate_profile?.affiliate_clean_url || product.value.product.product_url, '_blank');
  // product.value.type = 'product';
  // console.log('Open product detail:', product.value.product_url);
  // event.emit('open-share', product.value);
};
</script>

<style lang="scss">
.manage-product-item {
  --transition: all 0.3s ease;
  cursor: pointer;
  min-height: 100%;

  .featured-icon {
    height: 24px;
    width: 24px;
    border-radius: var(--radius-small);
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--Text-secondary);
    background-color: var(--Bg-light);
    position: absolute;
    z-index: 9;
    right: 8px;
    top: 8px;

    svg {
      width: 14px;
      height: 14px;
    }

    &.is-feature {
      color: var(--Yellow-30);
    }
  }

  .overlay {
    background-color: rgba(0, 0, 0, 0.5);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    transition: var(--transition);
    opacity: 0;

    .actives {
      display: flex;
      justify-content: space-between;
      padding: 8px;
      width: 100%;
    }

    .icon {
      height: 24px;
      width: 24px;
      border-radius: var(--radius-small);
      display: flex;
      align-items: center;
      justify-content: center;
      color: var(--Text-secondary);
      background-color: var(--Bg-light);

      svg {
        width: 14px;
        height: 14px;

        &.svg-icon__copy-link {
          width: 16px;
          height: 16px;
        }

        &.svg-icon__delete {
          width: 16px;
          height: 16px;
          fill: var(--Red-30);
        }

        &.svg-icon__bookmark {
          width: 16px;
          height: 16px;
        }
      }

      &:hover {
        background-color: var(--Neu-20);
        color: var(--Text-primary);
      }

      &.is-feature {
        color: var(--Yellow-30);
      }
    }

    .bottom-actives {
      display: flex;
      justify-content: flex-end;
      padding: 8px;
      width: 100%;
      gap: 8px;
      position: absolute;
      bottom: 0;
      left: 0;
    }
  }

  .count {
    position: absolute;
    bottom: 4px;
    right: 4px;
    background-color: var(--Black-90);
    color: var(--Black-00);
    padding: 0 8px;
    height: 24px;
    border-radius: var(--radius-small);
    font: var(--medium-14);
    display: flex;
    align-items: center;
    transition: var(--transition);

    svg {
      width: 16px;
      height: 16px;
      margin-right: 2px;
    }
  }

  figure {
    margin-bottom: 8px;
    display: block;
    padding-bottom: 100%;
    position: relative;
    border-radius: var(--radius);
    overflow: hidden;
    background-color: var(--Bg-01);
    aspect-ratio: 1 / 1;

    .el-image {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: block;

      img {
        object-fit: contain;
      }
    }
  }

  h3 {
    font: var(--medium-14);
    color: var(--Text-primary);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1;
  }

  .bot {
    display: flex;
    align-items: center;
    cursor: pointer;

    & > span {
      flex: 1;
      font: var(--medium-12);
      color: var(--Text-default);
    }

    .el-button {
      padding: 0;
      margin: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      color: var(--Text-default);
      height: 24px;
      width: 24px;
      border-radius: var(--radius-small);

      &:hover {
        background-color: var(--Neu-20);
        color: var(--Text-primary);
      }

      svg{
        width: 12px;
        height: 12px;
      }
    }
  }

  &:hover {
    .overlay {
      opacity: 1;
    }

    .count {
      opacity: 0;
    }
  }

  &.is-tag {
    background-color: var(--Bg-light);
    border-radius: var(--radius);
    overflow: hidden;
    border: 1px solid transparent;

    &.is-selected {
      border-color: var(--Text-brand);
    }

    .tag-ico {
      position: relative;
      height: 20px;
      width: 20px;
      display: flex;
      align-items: center;
      justify-content: center;

      &::before {
        height: 18px;
        width: 18px;
        border-radius: 50%;
        border: 2px solid var(--Black-60);
        content: '';
        box-sizing: border-box;
      }

      svg {
        height: 100%;
        width: 100%;
        fill: var(--Text-brand);
        display: none;
      }
    }

    &:hover {
      .tag-ico {
        &::before {
          border-color: var(--Text-brand);
        }
      }
    }

    .el-dropdown {
      display: none;
    }

    &.is-selected {
      .tag-ico {
        &::before {
          display: none;
        }

        svg {
          display: block;
        }
      }
    }

    .overlay {
      opacity: 1;
      background-color: transparent;

      .bottom-actives {
        display: none;
      }
    }

    figure {
      background-color: var(--Bg-light);
    }

    .count {
      display: none;
    }

    h3 {
      padding: 8px 16px 0;

    }

    .bot {
      padding: 8px 16px 12px;

    }
  }

  &.is-disabled {
    cursor: default;

    .bottom-actives .icon {
      display: none;

      &:last-child {
        display: flex;
      }
    }

    .bot .tag-ico,
    .actives {
      display: none;
    }

    .overlay {
      opacity: 1 !important;
      background-color: transparent !important;

      .bottom-actives {
        display: flex;
      }
    }

    .availability-icon {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: rgba(0, 0, 0, 0.5) !important;
      z-index: 1;
      transition: var(--transition);
      opacity: 1 !important;

      .availability-icon-text {
        padding: 12px;
        color: var(--Black-00);

        svg {
          width: 52px;
          height: 52px;
          fill: var(--Black-00);
          display: block;
          margin: 0 auto 12px;
        }

        p {
          font: var(--medium-14);
          color: var(--Black-00);
          text-align: center;
        }
      }
    }

    .el-dropdown {
      display: block;
    }

    &:hover {
      .availability-icon {
        opacity: 0;
      }
    }
  }
}

.manage-dropdown-menu.manage-product-dropdown-menu .el-dropdown-menu__item.delete-item {
  display: flex !important;
}
</style>
